// component
import SvgColor from '../../../components/svg-color';

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'Home',
    path: '/home2',
    icon: icon('ic_analytics'),
    supervisor: false
  },
  {
    title: 'Propostas',
    path: '/propostas2',
    icon: icon('list-outline'),
    supervisor: false
  },
  {
    title: 'Agenda',
    path: '/agenda2',
    icon: icon('agenda'),
    supervisor: false
  }
].filter(Boolean);

export default navConfig;